/**
 * Grabar audio obtenido del micrófono con JavaScript, seleccionando
 * un dispositivo de grabación de una lista; usando MediaRecorder
 * y getUserMedia
 * 
 * @author parzibyte
 * @see https://parzibyte.me/blog
 */
// const init = () =>

 // const init = () => {
 class record {

    constructor(api, axios, eventBus){
        // Declaración de elementos del DOM
        this.listaDeDispositivos     = { value : "", options: []};//document.getElementById("listaDeDispositivos"),
        this.duracion                = null;
        this.btnComenzarGrabacion    = null;
        this.btnDetenerGrabacion     = null;
        this.info                    = {};
        this.ml                      = null;
        this.Audio                   = null;
        this.axios                   = axios;
        this.api                     = api;
        this.EventBus                = eventBus;
        this.duration                = "";
        // Variables "globales"
        this.tiempoInicio; 
        this.mediaRecorder; 
        this.idIntervalo;

    }
    init(){

        const tieneSoporteUserMedia = () =>{
            // !!(navigator.mediaDevices.getUserMedia)
            if (navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                return true;
            }
            return false
        }

        // console.log("check media : ", tieneSoporteUserMedia());
        // Si no soporta...
        // Amable aviso para que el mundo comience a usar navegadores decentes ;)
        if (typeof MediaRecorder === "undefined" || !tieneSoporteUserMedia()){
            const timer = setTimeout(()=>{
                // alert(this.ml.get("your_browser_not_req"));
                console.warn(this.ml.get("your_browser_not_req"));
            },2500)
            return  // not_recording
        }
        
        // btnComenzarGrabacion.addEventListener("click", comenzarAGrabar);
        // btnDetenerGrabacion.addEventListener("click", detenerGrabacion);

        // Cuando ya hemos configurado lo necesario allá arriba llenamos la lista

        // console.log("start init record *****************")
        this.llenarLista();
    }

    start(){ // no in use
         // Esperar a que el documento esté listo...
        document.addEventListener("DOMContentLoaded", init());
    }

    get_list(key){
        if (key && this[key]) {
            return this[key];
        }
        return null

    }
    
    update_list(key, item){        
        if (key) {
            this[key] = item;
        }else{
            console.warn("set a key for set : ", key);
        }

    }

    set_html({duration, start, stop}){

        this.duracion                = document.getElementById(duration || "duracion");

        // console.log("record html ********* ", this.duracion, duration);
       /* this.btnComenzarGrabacion    = document.getElementById(start    || "btnComenzarGrabacion");
        this.btnDetenerGrabacion     = document.getElementById(stop     || "btnDetenerGrabacion");*/
    }

    set_audioinput(item){
        this.listaDeDispositivos.value = item;
    }

    // Algunas funciones útiles
    limpiarSelect(){
       /* for (let x = this.listaDeDispositivos.options.length - 1; x >= 0; x--) {
            this.listaDeDispositivos.options.remove(x);
        }*/
        this.listaDeDispositivos = {value : "", options: []}
    }

    segundosATiempo(numeroDeSegundos){
        let horas = Math.floor(numeroDeSegundos / 60 / 60);
        numeroDeSegundos -= horas * 60 * 60;
        let minutos = Math.floor(numeroDeSegundos / 60);
        numeroDeSegundos -= minutos * 60;
        numeroDeSegundos = parseInt(numeroDeSegundos);
        if (horas < 10) horas = "0" + horas;
        if (minutos < 10) minutos = "0" + minutos;
        if (numeroDeSegundos < 10) numeroDeSegundos = "0" + numeroDeSegundos;
        
        return `${horas}:${minutos}:${numeroDeSegundos}`;
    }
    
    refrescar(){
        this.duracion.textContent = this.segundosATiempo((Date.now() - this.tiempoInicio) / 1000);
        // console.log("********************** record", this.duracion, this.duracion.textContent)
    }
        // Consulta la lista de dispositivos de entrada de audio y llena el select
    llenarLista(){
        // console.log("record llenarLista ")
        let vm = this;
        navigator
            .mediaDevices
            .enumerateDevices()
            .then(dispositivos => {
                // console.log("record dispositivos ", dispositivos)
                // vm.limpiarSelect();
                this.listaDeDispositivos = {value : "", options: []}
                if (dispositivos && dispositivos.length > 0) {
                    let device_lang = this.ml.get("device");
                    dispositivos.forEach((dispositivo, indice) => {
                        // console.log("record type ", dispositivo)
                        if (dispositivo.kind === "audioinput") {
                            let option = {}//document.createElement("option");
                            // Firefox no trae nada con label, que viva la privacidad
                            // y que muera la compatibilidad

                            option.text  = dispositivo.label || `${device_lang} ${indice + 1}`;
                            option.value = dispositivo.deviceId;
                            this.listaDeDispositivos.options.push(option);
                            // console.log("record dispositivo ", dispositivo, option)
                            // listaDeDispositivos.appendChild($opcion);
                        }
                    })
                }
                // console.log("record list devices audio ", this.listaDeDispositivos );
            })
    }
    // Ayudante para la duración; no ayuda en nada pero muestra algo informativo
    comenzarAContar(){
        let vm  = this;
        this.tiempoInicio = Date.now();
        this.idIntervalo = setInterval(()=>{
            this.refrescar()
            // this.mediaRecorder.requestData();
        }, 1000);
    }

    // Comienza a grabar el audio con el dispositivo seleccionado
    comenzarAGrabar(){
        if (!this.listaDeDispositivos.options.length) return alert(this.ml.get("no_devices"));
        // No permitir que se grabe doblemente
        if (this.mediaRecorder) return alert(this.ml.get("it_being_recorded"));

        navigator.mediaDevices.getUserMedia({
                audio: {
                    deviceId: this.listaDeDispositivos.value,
                }
            })
            .then(
                stream => {
                    // Comenzar a grabar con el stream
                    this.mediaRecorder = new MediaRecorder(stream);
                    this.mediaRecorder.start(1000);
                    this.comenzarAContar();
                    // En el arreglo pondremos los datos que traiga el evento dataavailable
                    const fragmentosDeAudio = [];                   
                    // Escuchar cuando haya datos disponibles
                    this.mediaRecorder.addEventListener("dataavailable", evento => {
                        // Y agregarlos a los fragmentos
                        // fragmentosDeAudio[fragmentosDeAudio.length - 1].push(evento.data);
                        // console.log("DATA media ", evento)
                        // let chunk = new Blob([evento.data])
                        fragmentosDeAudio.push(evento.data);  // chunk               
                        this.emit_recording(evento.data);

                    });                   
                   /* this.mediaRecorder.ondataavailable = (e) => {
                        console.log("DATA chunks ", e)

                          chunks.push(e.data);
                        } */
                    // Cuando se detenga (haciendo click en el botón) se ejecuta esto
                    this.mediaRecorder.addEventListener("stop", () => {
                        // Detener el stream
                        stream.getTracks().forEach(track => track.stop());
                        // Detener la cuenta regresiva
                        this.detenerConteo();
                        // Convertir los fragmentos a un objeto binario
                        const blobAudio = new Blob(fragmentosDeAudio); // 
                        // this.Audio      = blobAudio;
                        this.save_audio(blobAudio);
                        console.log("record : blobAudio ", blobAudio, fragmentosDeAudio)
                        // Crear una URL o enlace para descargar
                        const urlParaDescargar = URL.createObjectURL(blobAudio);
                        // Crear un elemento <a> invisible para descargar el audio
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = urlParaDescargar;
                        a.download = "record.mp3"; // webm
                        // Hacer click en el enlace
                        a.click();
                        // Y remover el objeto
                        window.URL.revokeObjectURL(urlParaDescargar);
                    });
                }
            )
            .catch(error => {
                // Aquí maneja el error, tal vez no dieron permiso
                console.log(error)
            });
    }


    detenerConteo(){
        clearInterval(this.idIntervalo);
        this.tiempoInicio = null;
        this.duration               = this.duracion.textContent;
        this.duracion.textContent   = "";
    }

    detenerGrabacion(){
        if (!this.mediaRecorder) return alert(this.ml.get("not_recording"));
        this.mediaRecorder.stop();
        this.mediaRecorder = null;
    }

    emit_recording(fragmento){
        // console.log("Sending audio ", fragmento, this.info)
        if (this.info && this.info.deviceId) {
            this.EventBus.$emit("emit_to_channel",{
                workspace   : "data",
                channel     : "recording_audio",
                message     : {
                    deviceId    : this.info.deviceId,
                    audio       : fragmento
                },
            })
        }
    }

    save_audio(audio){
        const api       = this.api.url + "/api/v1/audio/import";
        let formData    = new FormData();
        formData.append("file", audio, "record.mp3");
        formData.append("duration", this.duration);        
        formData.append("deviceId", this.info.deviceId || null);



        this.axios.post(api, formData).then(res => {
            console.log("res audio ", res);
        }).catch(er => {
            console.warn("Error save audio", er);
        })
    }

}
   

export default record;